import { isArray, isNumber, isString, isUndefined, isValidModel } from '../utils';

export type Category = {
  id: number;
  name: string;
  pId: number;
  subCategories?: Category[];
  pointConversionRate?: number;
};

export const isCategory = (obj: any): obj is Category => {
  return isValidModel<Category>(obj, {
    id: isNumber,
    name: isString,
    pId: isNumber,
    subCategories: (value: any) => isUndefined(value) || (isArray(value) && value.every(isCategory)),
  });
};
